import s from './FilterButtonsTemplate.module.sass'
import FilterButtons from '../FilterButtons/FilterButtons'

import { FC, useState } from 'react'

import { useAppDispatch, useAppSelector } from '@app/model/store/client'

import {
  closeModalFilterList,
  resetFilterAsync,
  setCheckedFilterItemAsync,
} from '@features/Restaurant/RestaurantFilters/model/thunks'

import { TypeFiltersByKeyListButtons, TypeTag } from '@features/Restaurant/RestaurantFilters/model/types'
import { getFilterByType, getFilterSelected, toCheckboxOption } from '@features/Restaurant/RestaurantFilters/helpers'

import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { BtnFilterDropdown } from '@shared/ui/Form/Single/Filters/Dropdown'
import { Checkbox } from '@shared/ui/Form/Single/Checkbox'
import { CheckboxOption } from '@shared/types/fields/fields'
import { EGG } from '@shared/api/analytics'
import { Text } from '@shared/ui/Typography/Text'

type RenderCheckboxButtonParams = {
  tag: TypeTag
  changeChecked: (option: CheckboxOption, checked: boolean) => void
}

/**
 * @function renderCheckboxButton
 * рендерит чекбокс в режиме кнопки для элемента списка
 */
const renderCheckboxButton = (params: RenderCheckboxButtonParams) => {
  const { tag, changeChecked } = params
  return (
    <Checkbox
      key={`checkbox-${tag.id}`}
      option={toCheckboxOption(tag)}
      checked={tag.checked}
      onChange={changeChecked}
      mode={'button'}
      className={s.button}
    />
  )
}

interface Props {
  typeFilter: TypeFiltersByKeyListButtons
  handleSave: () => void
  handleRemove: () => void
}

const title = {
  rating: ['Рейтинг', 'Рейтинг'],
  price: ['Цена', 'Средний счет'],
}

const FilterButtonsTemplate: FC<Props> = ({ typeFilter, handleSave, handleRemove }) => {
  const dispatch = useAppDispatch()
  const stateFilters = useAppSelector((store) => store.features.restaurant_filters)
  const { list, checkedList } = stateFilters.filters[typeFilter]
  const [isOpenedPopup, setIsOpenedPopup] = useState(false)

  const handleRemoveInner = async () => {
    setIsOpenedPopup(false)
    await dispatch(resetFilterAsync(typeFilter))
    handleRemove()
  }

  const changeChecked = (option: CheckboxOption, checked: boolean) => {
    dispatch(
      setCheckedFilterItemAsync({
        filterType: typeFilter,
        itemId: Number(option.id),
        checked: checked,
      }),
    )
  }

  const handleSaveInner = () => {
    EGG.common.filter_use_click({
      filter_apply_type: typeFilter,
      filters_apply: getFilterSelected(),
      filter_apply_value: getFilterByType({ key: typeFilter }),
    })
    setIsOpenedPopup(false)
    handleSave()
  }

  const handleOpenPopup = () => {
    setIsOpenedPopup(() => true)
  }

  const handleClosePopup = () => {
    dispatch(closeModalFilterList(typeFilter))
    setIsOpenedPopup(() => false)
  }

  const listItems = list.map((tag) => renderCheckboxButton({ tag, changeChecked }))
  const emptyView = <Text sizes={'M'}>Ничего не найдено</Text>
  const listContent = [list.length > 0 && listItems, !list.length && emptyView].find(Boolean)

  return (
    <BlockBoundary>
      <div>
        <BtnFilterDropdown openedPopup={isOpenedPopup}>
          <BtnFilterDropdown.Button
            handleOpen={handleOpenPopup}
            handleClose={handleClosePopup}
            count={checkedList?.length || 0}
            handleRemove={handleRemoveInner}>
            {title[typeFilter][0]}
          </BtnFilterDropdown.Button>

          <BtnFilterDropdown.Popup
            title={title[typeFilter][1]}
            width={420}
            className={s.popup}
            handleClose={handleClosePopup}>
            <div className={s.list}>{listContent}</div>
            <FilterButtons handleRemove={handleRemoveInner} handleSave={handleSaveInner} />
          </BtnFilterDropdown.Popup>
        </BtnFilterDropdown>
      </div>
    </BlockBoundary>
  )
}

export default FilterButtonsTemplate
